import { render, staticRenderFns } from "./AtivoInativoComponent.vue?vue&type=template&id=598ab7c8"
import script from "./AtivoInativoComponent.vue?vue&type=script&lang=js"
export * from "./AtivoInativoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports